module.exports = __webpack_public_path__ + "static/media/clear-cache.6aa4bb0c.svg";